import React, { useEffect, useState } from 'react';

import Button from '../../../../library/button/button';
import ProductCompareOeCard from '../../../../components/product-compare-oe-card/product-compare-oe-card';
import ProductComparePreviewSummary from '../product-compare-preview-summary/product-compare-preview-summary';

import { useMediaQuery } from '../../../../shared/hooks/hooks';

import { getHasInstantPromotions } from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';
import { ProductQuantity } from '../../../../shared/types/product';

import './product-compare-preview.scss';

interface ProductComparePreviewProps {
  isFitmentSearch?: boolean;
  isSizeSearch?: boolean;
  isStaggeredSearch?: boolean;
  maxProductsForComparison: number;
  onClearAll: () => void;
  onClearProduct: () => void;
  productQuantities: Array<ProductQuantity>;
  productType?: string;
  productsForComparison: ProductData[];
  queryType?: string;
  updateShowCompareDrawer: (value?: boolean) => void;
}

const ProductComparePreview = React.forwardRef<
  HTMLDivElement,
  ProductComparePreviewProps
>(function ProductComparePreview(props) {
  const {
    isFitmentSearch = false,
    isSizeSearch = false,
    isStaggeredSearch = false,
    maxProductsForComparison,
    onClearAll,
    onClearProduct,
    productQuantities,
    productType,
    productsForComparison,
    queryType,
    updateShowCompareDrawer
  } = props;

  const productsForComparisonCount = productsForComparison?.length || 0;

  const disableCompare = productsForComparisonCount < 2;

  const hasInstantPromotions = getHasInstantPromotions(productsForComparison);

  const [headerElementHeight, setHeaderElementHeight] = useState(0);

  const { isMinMd, isMinSm } = useMediaQuery();

  useEffect(() => {
    setHeaderElementHeight(
      document.querySelector('header')?.getBoundingClientRect?.()?.height || 0
    );
  }, [isMinMd, isMinSm]);

  return (
    <div style={{ 'top': `${headerElementHeight}px` }} styleName="sticky">
      {productsForComparison?.length > 0 && maxProductsForComparison > 0 && (
        <div styleName="compare-preview">
          <div styleName="products-container">
            {[...Array(maxProductsForComparison)].map((_, idx) =>
              productsForComparison[idx] ? (
                <ProductComparePreviewSummary
                  hasInstantPromotions={hasInstantPromotions}
                  key={productsForComparison[idx]?.code ?? idx}
                  onClearProduct={onClearProduct}
                  product={productsForComparison[idx]}
                  productQuantityData={productQuantities?.[idx]}
                />
              ) : (
                <ProductCompareOeCard
                  currentIndex={idx}
                  isFitmentSearch={isFitmentSearch}
                  isSizeSearch={isSizeSearch}
                  isStaggeredSearch={isStaggeredSearch}
                  productType={productType}
                  queryType={queryType}
                />
              )
            )}
          </div>
          <div styleName="cta-container">
            <div styleName="ctas">
              <Button
                isDisabled={disableCompare}
                isSecondary
                onClick={() => updateShowCompareDrawer(true)}
                styleName="compare-btn"
              >
                Compare (
                {productsForComparisonCount > maxProductsForComparison
                  ? maxProductsForComparison
                  : productsForComparisonCount}
                )
              </Button>
              <Button onClick={onClearAll} styleName="clear-all">
                clear all tires
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default ProductComparePreview;
